export default "__VITE_ASSET__BgcjCkW0__"